import { gql } from '@apollo/client';

export const MarkChangelogSeenMutationName = 'MarkChangelogSeen';

export const MARK_CHANGELOG_SEEN_MUTATION = gql`
  mutation ${MarkChangelogSeenMutationName} {
    markChangelogSeen {
      ... on MarkChangelogSeenSuccess {
        viewer {
          id
          user {
            id
            unseenChangelogCount
          }
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
